<template>
  <div class="breadCrumb">
    <div><h3>Types de Chambre</h3></div>
    <div>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">Configurations</li>
          <li class="breadcrumb-item">Types de Chambre</li>
          <li class="breadcrumb-item active" aria-current="page">Modification</li>
        </ol>
      </nav>
    </div>
  </div>

  <div class="card" style="padding: 10px" v-if="!isLoading">
    <div class="row p-2">
      <div class="col-md-6">
        <div class="form-group">
          <label for="nom" class="form-label">Nom</label>
          <input
            type="text"
            id="nom"
            v-model="typeChambre.nom"
            class="form-control"
            :class="{ 'is-invalid': error.nom }"
            placeholder="Nom du type de chambre"
          >
          <div class="invalid-feedback">{{ error.nom }}</div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="tarifParJour" class="form-label">Tarif journalier (F CFA)</label>
          <input
            type="number"
            id="tarifParJour"
            v-model="typeChambre.tarifParJour"
            class="form-control"
            :class="{ 'is-invalid': error.tarifParJour }"
            placeholder="Ex : 25000"
          >
          <div class="invalid-feedback">{{ error.tarifParJour }}</div>
        </div>
      </div>
    </div>

    <div class="row p-2">
      <div class="col-md-12">
        <div class="form-group">
          <label for="description" class="form-label">Description</label>
          <textarea
            id="description"
            v-model="typeChambre.description"
            class="form-control"
            rows="3"
            placeholder="Description du type de chambre (optionnel)"
          ></textarea>
        </div>
      </div>
    </div>

    <div class="row p-2">
      <div class="col-md-6">
        <div class="form-check form-switch">
          <input
            class="form-check-input"
            type="checkbox"
            id="enabled"
            v-model="typeChambre.isEnabled"
          >
          <label class="form-check-label" for="enabled">Activé ?</label>
        </div>
      </div>
    </div>

    <div class="row p-2">
      <div class="d-flex justify-content-between">
        <button class="btn btn-danger p-2" @click="cancel">Annuler</button>
        <button class="btn btn-success p-2" :disabled="isLoading" @click="updateTypeChambre">
          <span v-if="isLoading">Chargement...</span>
          <span v-else>Enregistrer</span>
        </button>
      </div>
    </div>
  </div>

  <div v-else class="text-center my-5">
    <div class="spinner-border text-primary" role="status" style="width: 4rem; height: 4rem;">
      <span class="visually-hidden">Chargement...</span>
    </div>
    <p class="mt-2">Chargement des données...</p>
  </div>
</template>

<script>
import api from '@/api';

export default {
  data() {
    return {
      isLoading: true,
      typeChambre: {
        nom: '',
        tarifParJour: null,
        description: '',
        isEnabled: true,
      },
      error: {
        nom: '',
        tarifParJour: ''
      }
    };
  },
  computed: {
    currentUser() {
      return this.$store.getters.user;
    }
  },
  methods: {
    validateForm() {
      this.error = {
        nom: this.typeChambre.nom ? '' : 'Le Nom est requis',
        tarifParJour: this.typeChambre.tarifParJour ? '' : 'Le tarif journalier est requis'
      };
      return !Object.values(this.error).some(err => err !== '');
    },

    async loadTypeChambre() {
      try {
        const id = this.$route.params.id;
        const response = await api.getItem('type_chambres', id);
        this.typeChambre = {
          ...response.data,
          tarifParJour: Number(response.data.tarifParJour)
        };
      } catch (error) {
        console.error('Erreur lors du chargement du type de chambre', error);
        alert("Impossible de charger le type de chambre.");
        this.$router.push({ name: 'liste_type_chambre' });
      } finally {
        this.isLoading = false;
      }
    },

    async updateTypeChambre() {
      if (!this.validateForm() || this.isLoading) return;

      try {
        this.isLoading = true;

        const updatedType = {
          ...this.typeChambre,
          tarifParJour: Number(this.typeChambre.tarifParJour)
        };

        await api.updateItem('type_chambres', this.$route.params.id, updatedType);
        alert('Type de chambre mis à jour avec succès !');
        this.$router.push({ name: 'liste_type_chambre' });
      } catch (error) {
        console.error('Erreur lors de la mise à jour du type de chambre', error);
      } finally {
        this.isLoading = false;
      }
    },

    cancel() {
      this.$router.push({ name: 'liste_type_chambre' });
    }
  },
  created() {
    this.loadTypeChambre();
  }
};
</script>

<style scoped>
.breadCrumb {
  display: flex;
  justify-content: space-between;
  padding: 8px;
}
</style>
